import * as core from '../../../../../../../core'

import { query } from './pi-scatter.query'

export const RESOURCE = {
  payload: {
    alias: 'rp.overview.widgets.pi-performance-scatter',
    description: 'Scatter plot showing Density (Amount/Sqft) by PI',
    name: 'RP Overview - PI Performance Scatter',
    query,
    variables: [
      {
        id: 'asfMin',
        name: 'ASF Minimum',
        type: core.common.value.types.Intrinsic.Decimal,
      },
      {
        id: 'asfMax',
        name: 'ASF Maximum',
        type: core.common.value.types.Intrinsic.Decimal,
      },
    ],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
